import { generateRedirectUrl } from '@domain-group/javascript-utils'

type MergeHashQueryParamsWithRedirectParams = {
  hash: string,
  hashQueryParams?: {
    [key: string]: number | string | undefined,
  },
  includeRedirect?: boolean,
  redirectUrl?: string,
}

const mergeHashQueryParamsWithRedirect = (params: MergeHashQueryParamsWithRedirectParams) => {
  const {
    hash, hashQueryParams, includeRedirect, redirectUrl,
  } = params

  const redirect = includeRedirect ? `redirect=${redirectUrl || generateRedirectUrl()}` : ''
  const joinCharacter = hash.includes('?') ? '&' : '?'

  // Convert object { key: value } to string
  // e.g. key=value
  let stringifiedHashQueryParams = ''
  if (hashQueryParams){
    let itemCount = 0

    stringifiedHashQueryParams = Object.keys(hashQueryParams).map((key) => {
      const paramValue = hashQueryParams[key]
      if (!paramValue) return ''

      itemCount += 1

      if (itemCount === 1){ return `${key}=${paramValue}` }
      return `&${key}=${paramValue}`
    }).join('')

    // Add the join characted if we have params
    // otherwise we dont need if we are returning an empty string ''
    if (stringifiedHashQueryParams){
      stringifiedHashQueryParams = `${joinCharacter}${stringifiedHashQueryParams}`
    }
  }

  const hashWithParams = `${hash}${stringifiedHashQueryParams}`
  const redirectJoinCharacter = hashWithParams.includes('?') ? '&' : '?'

  return redirect ? `${hashWithParams}${redirectJoinCharacter}${redirect}` : hashWithParams
}

export default mergeHashQueryParamsWithRedirect
